export const MESSAGE_SEVERITY_SUCCESS = 'success';
export const MESSAGE_SEVERITY_ERROR = 'error';
export const MESSAGE_SEVERITY_INFO = 'info';
export const MESSAGE_SEVERITY_WARNING = 'warning';